import * as React from "react";

interface PlainHeaderProps {
    title: string;
}

const PlainHeader: React.FC<PlainHeaderProps> = (props: PlainHeaderProps) => {
    return (
        <div className="Details__header">
            <h1 className="Details__headerTitle">
                <span>{props.title}</span>
            </h1>
        </div>
    );
};

export default PlainHeader as any;
